module.exports = __webpack_public_path__ + "img/gallery-bailey1.fc275b75.jpg";